import React, { useEffect, useState } from 'react';
import { MediaRecording, RecordedData } from './MediaRecording';

interface ChatInputProps {
    input: string;
    setInput: (input: string) => void;
    sendMessage: () => void;
    isSending: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ input, setInput, sendMessage, isSending }) => {
    const [inputChangedByVoiceRecorder, setInputChangedByVoiceRecorder] = useState<boolean>(false);
    const onAudioCaptured = (recordedData: RecordedData) => {
        if (recordedData.text) {
            setInputChangedByVoiceRecorder(true);
            setInput(recordedData.text);
        }
    }
    useEffect(() => {
        if (inputChangedByVoiceRecorder) {
            setInputChangedByVoiceRecorder(false);
            sendMessage();
        }
    }, [sendMessage, inputChangedByVoiceRecorder, input])

    return (
        <div className="flex-none items-center pt-0">
            <form className="flex items-center justify-center w-full space-x-2" onSubmit={(e) => { e.preventDefault(); sendMessage(); }}>
                <MediaRecording recording={window.location.search.toLowerCase().indexOf('video') >= 0 ? 'image': 'audio'} onDataAvailable={onAudioCaptured} onStartRecording={() => {}}/>
                <input
                    className="flex h-10 w-full rounded-md border border-[#e5e7eb] px-3 py-2 text-sm placeholder-[#6b7280] focus:outline-none focus:ring-2 focus:ring-[#9ca3af] disabled:cursor-not-allowed disabled:opacity-50 text-[#030712] focus-visible:ring-offset-2"
                    placeholder="Deine Anfrage"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                    disabled={isSending}
                />
                <button
                    type="submit"
                    className="inline-flex items-center justify-center rounded-md text-sm font-medium text-[#f9fafb] disabled:pointer-events-none disabled:opacity-50 bg-[rgb(68,68,68)] hover:bg-[rgb(193,0,0)] h-10 px-4 py-2" disabled={isSending}
                >
                    Senden
                </button>
            </form>
        </div>
    );
};

export default ChatInput;
